export default "__VITE_ASSET__ruTxLn0M__"